import store from '../store'
import {
    SET_ON_BOARDING_STEP,
    SET_ON_BOARDING_SPORTS,
    SET_USER_SPORT,
    SET_SPORT_RELATIONSHIP,
    FETCH_SPORTS_IS_PENDING,
    SET_ON_BOARDING_PLACE,
    SET_ON_BOARDING_BIRTHDAY,
    SET_ON_BOARDING_ACHIEVEMENT_SPORT,
    SET_ON_BOARDING_ACHIEVEMENT_TEXT,
    SET_ON_BOARDING_FINISHED,
    SET_USER_SPORT_OBJECT,
} from '../reducers/on-boarding'

/**
 * Set current on boarding step
 * @param {number} step
 */
export const setOnBoardingStepAction = step => {
    window.location.hash = `#on-boarding-${step}`
    store.dispatch({
        type: SET_ON_BOARDING_STEP,
        step: step,
    })
}

/**
 * Set array of sports
 * @param {Array} sports
 */
export const setOnBoardingSportsAction = sports => {
    store.dispatch({
        type: SET_ON_BOARDING_SPORTS,
        sports: sports,
    })
}

/**
 * Set if sports are now fetching
 * @param {boolean} isPending
 */
export const fetchSportsIsPendingAction = isPending => {
    store.dispatch({
        type: FETCH_SPORTS_IS_PENDING,
        isPending: isPending,
    })
}

/**
 * Set user selected sport
 * @param {Object} sports
 */
export const setUserSportAction = sports => {
    store.dispatch({
        type: SET_USER_SPORT,
        userSport: sports,
    })
}

/**
 * Set user sport object action
 *
 * @param {Object} userSport
 */
export const setUserSportObjectAction = userSport => {
    store.dispatch({
        type: SET_USER_SPORT_OBJECT,
        userSport: userSport,
    })
}

/**
 * Set user relationship to sport
 * @param {Array} relations
 */
export const setSportRelationshipAction = relations => {
    store.dispatch({
        type: SET_SPORT_RELATIONSHIP,
        relationToSport: relations,
    })
}

/**
 * Set users place (city)
 * @param {Object} place
 */
export const setOnBoardingPlaceAction = place => {
    store.dispatch({
        type: SET_ON_BOARDING_PLACE,
        place: place,
    })
}

/**
 * Set users date of birthday
 * @param {string} date
 */
export const setOnBoardingBirthdayAction = date => {
    store.dispatch({
        type: SET_ON_BOARDING_BIRTHDAY,
        date: date,
    })
}

export const setAchievementSportAction = sport => {
    store.dispatch({
        type: SET_ON_BOARDING_ACHIEVEMENT_SPORT,
        sport: sport,
    })
}

export const setAchievementTextAction = text => {
    store.dispatch({
        type: SET_ON_BOARDING_ACHIEVEMENT_TEXT,
        text: text,
    })
}

export const setFinishedOnBoardingAction = finished => {
    window.location.hash = ''
    store.dispatch({
        type: SET_ON_BOARDING_FINISHED,
        finished: finished,
    })
}

/**
 * Fetch sports and save into on boarding store
 * @returns {Promise<any>}
 */
export const fetchSports = () => {
    fetchSportsIsPendingAction(true)

    return window.axios.get(`${window.APP_CONFIG.REACT_APP_API_URL}api/sport-categories`)
        .then(({ data }) => {
            fetchSportsIsPendingAction(false)
            setOnBoardingSportsAction(data.data)
        })
}
